// extracted by mini-css-extract-plugin
module.exports = {"pocWrap":"purify_index__pocWrap--988Sh","hasData":"purify_index__hasData--1Pqu0","iconHolder":"purify_index__iconHolder--2qr8B","textHolder":"purify_index__textHolder--1fTX1"};